import EventsFeed from '../EventsFeed';
export default [
  {
    name: 'Home',
    path: '/',
    component: EventsFeed,
    props: true
  }
];
